module.exports = __webpack_public_path__ + "img/34.fixed_lightning.76268607.svg";